export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wsWorker.worker.c7576e02.worker.js");
}
